module.exports = __webpack_public_path__ + "fonts/fontagon-icons.2df69d5.woff";